import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthService from "./AuthService";
import "./Login.css";
// import "../../style/Common.css"; // Removing legacy common styles to prevent conflicts

const Login = ({ setUserType }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is already logged in
    const isAuthenticated = AuthService.isAuthenticated();
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      setLoading(false);
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await AuthService.login(credentials);
      if (response && response.token && response.role) {
        setUserType(response.role);
        navigate("/dashboard");
      }
    } catch (error) {
      alert("Invalid login!");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="auth-page">
      {/* Background Orbs */}
      <div className="bg-orbs">
        <div className="orb-1"></div>
        <div className="orb-2"></div>
      </div>

      {/* Glassmorphic Auth Card */}
      <div className="auth-card">
        <Link to="/">
          <img src="/ezzDesk_Logo.svg" alt="EzzDesk Logo" className="auth-logo" />
        </Link>
        
        <h1 className="auth-title">Log in to your account</h1>
        
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            name="email"
            type="email"
            placeholder="Email address"
            onChange={handleChange}
            required
            className="auth-input"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            required
            className="auth-input"
          />
          
          <div className="auth-options">
            <label className="auth-checkbox">
              <input type="checkbox" />
              Remember me
            </label>
            <a href="/forgot-password" className="auth-link">Forgot password?</a>
          </div>

          <button type="submit" className="auth-button">Sign In</button>
        </form>

        <p className="auth-footer">
          Don't have an account? <Link to="/register" className="auth-link">Create free account</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
